<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择事故"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
    >
      <section slot="tableSlot" slot-scope="scope">
        {{scope.row[scope.column.property]}}
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  claimsDialogList,
} from 'api/system';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showName: 'accidentTime',
      tableSelectTar: 'id',
      searchBoxDataTmpl: {
        form: [
          { // 事故地点
            label: '事故地点',
            value: 'accidentPlace',
            type: 'input',
            placeholder: '请输入事故地点',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'accidentTime',
          label: '事故时间',
        },
      ],
      tableTitle: [
        {
          prop: 'accidentTime',
          label: '事故时间',
        },
        {
          prop: 'accidentAddress',
          label: '事故地点',
        },
        {
          prop: 'verfyClaimAmount',
          label: '核赔金额',
        },
        {
          prop: 'ourLossAmount',
          label: '我方损失金额',
        },
        {
          prop: 'otherLossAmout',
          label: '对方损失金额',
        },
      ],
    };
  },
  methods: {
    getListApi: claimsDialogList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
  },
};
</script>

<style>

</style>
